import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import { healthFacilities, nationalCenter, unitExportId } from '../../../libs/services';

var Config = require('../../../config');

class ModalShippingDetails extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			requested_by:"",
			req_by:"",
			requested_to:"",
			req_to:"",
			messenger:"",
			observations:"",
			hour:"",
			date_form:"",
			priority:"",
			unitsSolicited:[],
			user:""
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	async handleShow(item){
		this.props.waiting.handleShow('Cargando...');
		var response = await unitExportId(item.unit_export.id);
		if(response !== undefined){
			var date = new Date(response.date);
			 //obtener usuario
			var user = JSON.parse(sessionStorage.getItem('medical_staff'));

			var name = ""
			if (user.names) {name += user.names};
			if (user.lastname1) {name += ' '+user.lastname1};
			if (user.lastname2) {name += ' '+user.lastname2};

			this.setState({
				user :  response.medical_staff,
				requested_by:response.shipper_center_id,
				requested_to:response.acceptor_center_id,
				req_to:response.acceptor_center,
				messenger: response.mensajero,
				observations: response.observaciones,
				hour: moment(response.hour, 'HH:mm:ss').format('HH:mm'),
				date_form : date.getFullYear()+'-'+("0" + (date.getMonth() + 1)).slice(-2)+'-'+("0" + date.getDate()).slice(-2),
				priority: response.priority.indexOf('HORAS') !== -1 ? '24 Horas' : 'Urgente',
				unitsSolicited:response.units,
				show: true,
				title: "Ver detalles del Envío"
			});

			this.getHealthFacilities();

		}

		this.props.waiting.handleClose();
	}

	async getHealthFacilities(){
		//traer hospitales
		var response = await healthFacilities();
		if(response !== undefined){
			for (var i = 0; i < response.length; i++) {
				if (response[i].id === this.state.requested_by) {
					this.setState({req_by:response[i].name});
					break
				}
			}

			this.getNationalCenters();
		}
		
	}

	async getNationalCenters(){
		var response = await nationalCenter();
		if(response !== undefined){
			for (var i = 0; i < response.length; i++) {
				console.log(response[i].national_center.id, this.state.requested_to)
				if (response[i].national_center.id === this.state.requested_to) {
					this.setState({req_to:response[i].national_center.name+
								(response[i].address.estado !== null ? ' - '+response[i].address.estado : "")});
					break;
				};
				
			};
		}
	}

	handleClose(){
		this.setState({
			show: false
		});
	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{this.state.title}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Centro Distribuidor</span>
		        				<input type="text" className="form-control" value={this.state.req_to} disabled/>
		        			</div>
		        		</div>
		        		<div className="col-xs-12">
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Fecha</span>
		        				<input type="date" className="form-control" value={this.state.date_form} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Hora</span>
		        				<input type="text" className="form-control" value={this.state.hour} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Prioridad</span>
		        				<input type="text" className="form-control" value={this.state.priority} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Usuario Solicita</span>
		        				<input type="text" className="form-control" value={this.state.user} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Mensajero</span>
		        				<input type="text" className="form-control" value={this.state.messenger} disabled/>
		        			</div>

		        			<div className="col-xs-12">
		        				<span className="span-min">Observaciones</span>
		        				<textarea className="form-control" value={this.state.observations} disabled></textarea>
		        			</div>
		        		</div>
		        		<div className="col-xs-12">
		        			<fieldset>
			        			<legend>Unidades </legend>
			        			<Table responsive hover>
			        				<thead>
					                  	<tr>
						                    <th>No. Donación</th>
						                    <th>Componente Sanguineo</th>
						                    <th>Grupo y RH</th>
						                    <th>Volumen</th>
											<th>Devuelta</th>
					                  	</tr>
					                </thead>
					                <tbody>
					                 	{this.state.unitsSolicited.map( (unit, index) => (
					                    	<tr key={index}>
					                      		<td>{unit.unit.unit_number}</td>
						                      	<td>{unit.blood_component_name}</td>
						                      	<td>{unit.unit.group+(unit.unit.rh === 'POSITIVO' ? '+':
						                      		unit.unit.rh === 'NEGATIVO' ? '-' : '')}</td>
						                      	<td>{unit.unit.volume} </td>
												<td>{unit.returned_timestamp === null ? "" : "SI"} </td>
					                    	</tr>
					                  	))}
					                </tbody>
			        			</Table>
			        		</fieldset>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>

		)
	}

} 

export default translate('translations') (ModalShippingDetails);